import { render, staticRenderFns } from "./CaseNotes.vue?vue&type=template&id=10702a38"
import script from "./CaseNotes.vue?vue&type=script&lang=js"
export * from "./CaseNotes.vue?vue&type=script&lang=js"
import style0 from "./CaseNotes.vue?vue&type=style&index=0&id=10702a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports